module.exports = __webpack_public_path__ + "a6927e438ac0588663bf935ec83844e2.ttf";